/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet } from 'aphrodite';
import { isEmptyValue, Checkbox } from '@blend/enterprise-components';

import { WrappedInput } from 'blb-components/WrappedInput';
import { FinalFormInputConfig } from 'blb-ui-types/helpers';

import { ComplianceInputLabel } from './ComplianceInputLabel';

const styles = StyleSheet.create({
  fieldWrapperSm: {
    ':not(:last-child)': {
      marginBottom: 8,
    },
  },
});

// the `checked` prop is managed internally by react-final-form
export const complianceInput: FinalFormInputConfig<Omit<Checkbox.Props, 'checked'>, string> = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapperSm],
  customComponentProps: {},
  displayAdditionalMessagingInContainer: false,
  inputComponent: Checkbox,
  label: <ComplianceInputLabel />,
  labelPosition: 'right',
  labelSize: 'sm',
  name: 'acceptedCompliance',
  type: 'checkbox',
  validate: isEmptyValue('You must agree to the Terms of Use and Privacy policy before proceeding'),
};
